import { jsx } from 'react/jsx-runtime';
import BackDropLiftContainer from '../../Utils/BackDropLiftContainer/BackDropLiftContainer.js';
import Portal from '../../Utils/Portal/Portal.js';
import DialogBox from '../DialogBox/DialogBox.js';

/**
 * 다이얼로그 컴포넌트
 * @param {Object} props
 * @param {boolean} props.isOpen - 다이얼로그 표시 여부
 * @param {string} [props.rootId] - 포털 루트 ID
 * @param {string} props.title - 다이얼로그 제목
 * @param {string} props.description - 다이얼로그 설명
 * @param {'primary'|'caution'} [props.variant='primary'] - 다이얼로그 스타일
 * @param {() => void} [props.onClose] - 닫기 핸들러
 * @param {() => void} [props.onConfirm] - 확인 핸들러
 * @param {string} [props.confirm] - 확인 버튼 텍스트
 * @param {string} [props.close='닫기'] - 닫기 버튼 텍스트
 * @param {boolean} [props.needCleanup=true] - 포털 정리 필요 여부
 */ const Dialog = ({ isOpen, rootId, title, description, variant = 'primary', onClose, onConfirm, confirm, close = '닫기', needCleanup = true })=>{
    const shouldCleanupPortal = needCleanup && !rootId;
    return /*#__PURE__*/ jsx(Portal, {
        rootId: rootId,
        needCleanup: shouldCleanupPortal,
        children: /*#__PURE__*/ jsx(BackDropLiftContainer, {
            isOpen: isOpen,
            onClose: onClose,
            testId: "design-system--dialog",
            children: /*#__PURE__*/ jsx(DialogBox, {
                title: title,
                description: description,
                variant: variant,
                onConfirm: onConfirm,
                onClose: onClose,
                confirm: confirm,
                close: close
            })
        })
    });
};

export { Dialog as default };
